<template>
  <div class="tag-container">
    <span class="tag is-info is-medium" v-for="(item, index) in list">
      {{item[label]}}
      <button class="delete is-small" @click="onDelete(index)"></button>
    </span>
  </div>
</template>
<script type="text/babel">
  export default {
    props:{
      /**
       * tagGroup的数据源
       */
      source:{
        type:Array,
        default:[]
      },
      /**
       *单个tag数据中用作显示的字段
       */
      label:{
        type:String,
        default:'name'
      },
      /**
       * 同时存在多个tagGroup时，用来作为标识量
       */
      id:{
        type:Number,
        default:0
      }
    },
    data(){
      return {

      }
    },
    computed:{
      list(){
        return JSON.parse(JSON.stringify(this.source))
      }
    },
    created(){

    },
    methods:{
      onDelete(index){
        this.source.splice(index,1)
      }
    }
  }
</script>
<style lang="less">
  .tag-container {
    display: flex;
    flex-wrap: wrap;
    .tag {
      margin-left: 10px;
      margin-top: 10px;
    }
  }
</style>
